<template>
  <div class="container-fluid border-end">
    <form @submit.prevent="submitForm">
      <div class="mb-3">
        <label for="transferBatchNo" class="form-label"
          >Transfer Batch No.</label
        >
        <input
          type="text"
          class="form-control"
          id="transferBatchNo"
          v-model="transferBatchNo"
        />
      </div>
      <div class="mb-3">
        <label for="transferringAgency" class="form-label"
          >Transferring Agency</label
        >

        <select
          v-model="transferringAgency"
          id="transferring-agency"
          class="form-select"
          style="width: 100%"
        >
          <option selected value="">Select...</option>
          <option v-for="data in AgencyList" :value="data['AgencyName']">
            {{ data["AgencyDisplayName"] }}
          </option>
        </select>
        <!-- <input
          type="text"
          class="form-control"
          id="transferringAgency"
          v-model="transferringAgency"
        /> -->
      </div>
      <div class="mb-3">
        <label for="transfer-date" class="form-label">Transfer Date</label>
        <input
          type="date"
          class="form-control"
          id="transfer-date"
          v-model="transferDate"
        />
      </div>
      <div class="mb-3">
        <label for="security-grading" class="form-label"
          >Security Grading</label
        >
        <select
          v-model="securityGrading"
          id="security-grading"
          class="form-select"
        >
          <option selected value="">Select...</option>
          <option value="Confidential">Confidential</option>
          <option value="Confidential (Cloud-eligible)">
            Confidential (Cloud-eligible)
          </option>
          <option value="Restricted">Restricted</option>
          <option value="Official (Closed)">Official (Closed)</option>
          <option value="Official (Open)">Official (Open)</option>
          <option value="Secret">Secret</option>
          <option value="Unclassified">Unclassified</option>
          <!-- <option value="Undefined">Undefined</option> -->
        </select>
      </div>
      <div class="mb-3">
        <label for="sensitivity-classification" class="form-label"
          >Sensitivity Classification</label
        >
        <select
          v-model="sensitivityClassification"
          id="sensitivity-classification"
          class="form-select"
        >
          <option selected value="">Select...</option>
          <!-- <option value="Undefined">Undefined</option> -->
          <option value="Non-Sensitive">Non-Sensitive</option>
          <option value="Sensitive Normal">Sensitive Normal</option>
          <option value="Sensitive High">Sensitive High</option>
        </select>
      </div>
      <div class="mb-3">
        <label for="sensitivity-classification" class="form-label"
          >Transfer Not Scheduled</label
        >
        <select
          v-model="sensitivityClassification"
          id="sensitivity-classification"
          class="form-select"
        >
          <option selected value="">Select...</option>
          <!-- <option value="Undefined">Undefined</option> -->
          <option value="Non-Sensitive">YES</option>
          <option value="Sensitive Normal">NO</option>

        </select>
      </div>
      <div class="mb-3">
        <label for="uuid" class="form-label">DIP UUID</label>
        <input type="text" class="form-control" id="uuid" v-model="uuid" />
      </div>
      <div class="d-block">
        <button
          @click="clearAll"
          class="btn btn-clear btn-outline-secondary"
          type="button"
        >
          Clear All
        </button>
        <button
          class="btn btn-search btn-primary"
          type="button"
          @click="submitForm"
        >
          Search
        </button>
      </div>
    </form>
  </div>
</template>

<script setup lang="ts">
import AgencyList from "../../../public/AgencyList.json";
import { useDIPStore } from "@/stores/dip";
import moment from "moment";
import { ref } from "vue";

const DipStore = useDIPStore();
const transferBatchNo = ref(DipStore.currentFilters[0].filterText);
const transferringAgency = ref(DipStore.currentFilters[1].filterText);
const transferDate = ref(DipStore.currentFilters[2].filterText);
const securityGrading = ref(DipStore.currentFilters[3].filterText);
const sensitivityClassification = ref(DipStore.currentFilters[4].filterText);
const uuid = ref(DipStore.currentFilters[5].filterText);
const convertedTransferDate = ref("");
const dayRange = 86399;
const emit = defineEmits(["listenTransferNumber"]);

const submitForm = () => {
  if (transferDate.value)
    convertedTransferDate.value = `${moment(transferDate.value).unix()}-${
      moment(transferDate.value).unix() + dayRange
    }`;

  let searchField = {
    transferNo: transferBatchNo.value,
    transferAgency: transferringAgency.value,
    transferDate: convertedTransferDate.value,
    securityGrading: securityGrading.value,
    sensitivityClassification: sensitivityClassification.value,
    uuid: uuid.value,
  };
  emit("listenTransferNumber", searchField);
};

const clearAll = () => {
  transferringAgency.value = "";
  transferBatchNo.value = "";
  transferDate.value = "";
  securityGrading.value = "";
  sensitivityClassification.value = "";
  convertedTransferDate.value = "";
  uuid.value = "";
  let searchField = {
    transferNo: transferBatchNo.value,
    transferAgency: transferringAgency.value,
    transferDate: convertedTransferDate.value,
    securityGrading: securityGrading.value,
    sensitivityClassification: sensitivityClassification.value,
    uuid: uuid.value,
  };
  emit("listenTransferNumber", searchField);
};
</script>

<style scoped>
.container-fluid {
  position: fixed;
  padding-top: 20px;
  width: 24%;
  height: 100%;
  overflow: auto;
}
.btn-clear {
  margin-top: 1rem;
  margin-right: 1%;
  width: 49%;
  margin-bottom: 5rem;
}
.btn-search {
  margin-top: 1rem;
  margin-left: 1%;
  width: 49%;
  margin-bottom: 5rem;
}
</style>
